export default function dialogReview({main, elm, state, subscribe}) {
	const dialog = elm.closest('dialog');
	const slider = elm.querySelector('.swiper--photos');
	const sliderWrapper = slider.querySelector('.swiper-wrapper');

	main(_ => {
		subscribe('review:open', open);
	});

	const open = function (review) {
		state.set(s => s.review = review);

		let slides = '';
		review.photos.forEach(photo => {
			slides += `
			<div class="review-photo swiper-slide--photo">
				<img src="${photo}" class="review-photo__img" alt="">
		  	</div>
			`;
		});

		sliderWrapper.innerHTML = slides;
		dialog.showModal();
		slider.swiper.update();
	};
};

export const model = {};
